import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); return; }
      } catch {}
      tries += 1;
      if (tries >= 10) { setStatus("timeout"); return; }
      setTimeout(tick, 2000);
    };
    tick();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      {status === "polling" && (
        <>
          <Loader2 size={48} className="mx-auto animate-spin text-zinc-400"/>
          <h1 className="font-display text-3xl mt-4">Confirming your payment…</h1>
          <p className="text-sm text-zinc-500 mt-2">This should take just a moment.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 size={56} className="mx-auto text-[var(--sage)]"/>
          <h1 className="font-display text-4xl mt-4">You're enrolled!</h1>
          <p className="text-zinc-600 mt-2">Your seat is saved. Dive into your dashboard to get started.</p>
          <Link to="/dashboard" className="btn-terracotta inline-block mt-6 px-5 py-3 rounded-full text-sm font-semibold" data-testid="success-dashboard-btn">Go to dashboard</Link>
        </>
      )}
      {(status === "failed" || status === "timeout") && (
        <>
          <XCircle size={56} className="mx-auto text-red-500"/>
          <h1 className="font-display text-4xl mt-4">{status === "timeout" ? "Still waiting…" : "Payment didn't complete"}</h1>
          <p className="text-zinc-600 mt-2">{status === "timeout" ? "Refresh in a minute to check again." : "No charge made - please try again."}</p>
          <Link to="/courses" className="chip inline-block mt-6">Back to courses</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      <XCircle size={56} className="mx-auto text-zinc-400"/>
      <h1 className="font-display text-4xl mt-4">Payment canceled</h1>
      <p className="text-zinc-600 mt-2">No worries - you can enroll any time.</p>
      <Link to="/courses" className="btn-ink inline-block mt-6 px-5 py-3 rounded-full text-sm font-semibold">Back to courses</Link>
    </div>
  );
}
